// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );


// Timeline init
let about_tl = gsap.timeline( { defaults: { repeat: 0, duration: 0.5, ease: 'power4.out'} } );

if( $('body').hasClass('who-we-are-page') ) {
    // Tween 1: background
    // about_tl.from( 
    //     $('#about'), 
    //     {
    //         backgroundPosition: '100% 0%',
    //         backgroundSize: '50%',
    //         // duration: 4,
    //     },
    // 0);

    // Tween 2: image from the left
    about_tl.from( 
        $('#about .img-container'), 
        {
            autoAlpha: 0,
            // duration: 2,
            xPercent: -100,
        },
    0);
    // Tween 3: image border appear
    about_tl.from( 
        $('#about .img-container .float-border'), 
        {
            autoAlpha: 0,
            // duration: 2,
            y: '20%',
            x: '32%',
        },
    0.3);

    // Tween 4: title up
    about_tl.from( 
        $('#about #about-text h2'), 
        {
            // duration: 2,
            yPercent: -100,
        },
    0);

    // Tween 5: stagger paragraphs from the right
    about_tl.from( 
        $('#about #about-text p'), 
        {
            autoAlpha: 0,
            // duration: 2,
            stagger: 0.1,
            yPercent: -20,
        },
    0.7);
}